import React from 'react'
import LocalShipping from '@mui/icons-material/LocalShipping';
import BusinessUnitHierarchyList from './HierarchyList';
import BusinessUnitFlatList from './FlatList';
import FlatEdit from './FlatEdit';
import BusinessUnitList from './HierarchyList';
import HierarchyEdit from './HierarchyEdit';
import Create from './Create'

//true
const isHierarchy = true; // expects true or false injected by plop

const listComponent = isHierarchy
  ? BusinessUnitHierarchyList
  : BusinessUnitFlatList;


const editComponent = isHierarchy
  ? HierarchyEdit
  : FlatEdit;

const conf = {
    name: 'kraftheinz_business_unit',
    icon: <LocalShipping />,
    list: listComponent,
    edit: editComponent,
    create: Create,
    options: {
        label: "Business Unit",
        items: true
    }
};

export default conf;